import script from "./AdminRecordScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRecordScreen.vue?vue&type=script&setup=true&lang=js"

import "./AdminRecordScreen.vue?vue&type=style&index=0&id=6502496a&scoped=true&lang=css"
import "./AdminRecordScreen.vue?vue&type=style&index=1&id=6502496a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6502496a"]])

export default __exports__